import { render, staticRenderFns } from "./RemoveMovie.vue?vue&type=template&id=841a38f4&scoped=true&"
import script from "./RemoveMovie.vue?vue&type=script&lang=js&"
export * from "./RemoveMovie.vue?vue&type=script&lang=js&"
import style0 from "./RemoveMovie.vue?vue&type=style&index=0&id=841a38f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a38f4",
  null
  
)

component.options.__file = "RemoveMovie.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
